// extracted by extract-css-chunks-webpack-plugin
module.exports = {"instructionsGif":"instructions-by-browser__instructionsGif__3IS-b"};